export type Bonus = {
  number: string
  title: string
  body: string
  accent: string
  /** Optional rendered cover. When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 30-Day Quick-Start Roadmap',
    body: 'Six volumes, one clear starting line. A day-by-day plan for your first four weeks: what to read, which Ready-Run Session to run and in what order — so you’re teaching from the pack this week, not after reading 300 pages.',
    accent: 'bg-gold',
    cover:
      'https://cdn.magicpatterns.com/uploads/4kWBoHo5SMAmEzzMXrgTkH/DPS-34_-_Bono_1_-_The_30-Day_Quick-Start_Roadmap.png',
  },
  {
    number: '02',
    title: 'Parkour on a Budget: Gear & DIY Setup Guide',
    body: 'Run full classes with little or no equipment. What to buy first, safe DIY obstacle builds, an “if you don’t have X, use Y” table and a setup checklist. No boxes or rails is no longer a reason to wait.',
    accent: 'bg-teal',
    cover:
      'https://cdn.magicpatterns.com/uploads/d8B7mnbKS61kpVcygGw5MV/DPS-34_-_Bono_2_-_Parkour_on_a_Budget_-_Gear__DIY_Setup_Guide.png',
  },
  {
    number: '03',
    title: 'The Parkour Class Music & Energy Guide',
    body: 'Use rhythm to steer the room. BPM ranges for every block of the session — warm-up, skill, game, cool-down — and how to build a class playlist around them, without depending on any specific track.',
    accent: 'bg-gold',
    cover:
      'https://cdn.magicpatterns.com/uploads/aRNswTNJPz1NA9TT1VGpdh/DPS-34_-_Bono_3_-_The_Parkour_Class_Music__Energy_Guide.png',
  },
  {
    number: '04',
    title: 'The Nervous-Beginner Fast-Track',
    body: 'For the kid (or adult) who’s scared to try. A confidence ladder that works across every skill, the exact phrases that lower fear, the coach mistakes that make it worse, and three micro-wins for the first class.',
    accent: 'bg-teal',
    cover:
      'https://cdn.magicpatterns.com/uploads/gcGqA5XToSdoF8VbQarUmF/DPS-34_-_Bono_4_-_The_Nervous-Beginner_Fast-Track.png',
  },
  {
    number: '05',
    title: 'The First-Class Script',
    body: 'Word for word, what to say in your first class with a new group: welcome, rules, safety brief, icebreaker and close — in kids, teens and rec versions. Lead with authority from minute one.',
    accent: 'bg-gold',
    cover:
      'https://cdn.magicpatterns.com/uploads/nZez9AVDxMcgoPMzxoCZCC/DPS-34_-_Bono_5_-_The_First-Class_Script.png',
  },
]
